import { SUPPORTED_LOCALES as e, normalizeLocale as t } from "./config.mjs";
import { webLocaleAdapter as n } from "./adapter/webLocaleAdapter.mjs";
import { DEFAULT_NAMESPACE as r, LAZY_LOCALE_LOADERS as i, resources as a } from "./locales/resources.mjs";
import { initReactI18next as o } from "react-i18next";
import s from "i18next";
//#region src/i18n.ts
s.isInitialized || s.use(o).init({
	resources: a,
	lng: n.getInitialLocale(),
	fallbackLng: "en",
	supportedLngs: [...e],
	defaultNS: r,
	initAsync: !1,
	partialBundledLanguages: !0,
	interpolation: { escapeValue: !1 },
	react: { useSuspense: !1 }
});
var c = new Set(["en"]), l = /* @__PURE__ */ new Map(), u = (e) => c.has(t(e) ?? "en"), d = (e) => {
	let n = t(e) ?? "en";
	if (c.has(n)) return Promise.resolve();
	let r = i[n];
	if (!r) return Promise.resolve();
	let a = l.get(n);
	return a || (a = r().then((e) => {
		for (let [t, r] of Object.entries(e.default)) s.addResourceBundle(n, t, r, !0, !0);
		c.add(n);
	}).finally(() => l.delete(n)), l.set(n, a)), a;
}, f = async (e) => {
	await d(e), await s.changeLanguage(t(e) ?? "en");
}, p = d(s.language).catch(() => void 0);
//#endregion
export { f as changeLanguage, d as ensureLocaleLoaded, s as i18n, p as i18nReady, u as isLocaleLoaded };
